import { MoreVertical, FileText, Phone, Mail } from "lucide-react";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
  DropdownMenuLabel,
} from "@/components/ui/dropdown-menu";
import { useState } from "react";
import { ContactNotesDialog } from "./ContactNotesDialog";
import { ContactDetailsDialog } from "./ContactDetailsDialog";

interface ContactLeadActionsMenuProps {
  contactId: string;
  contactData: any;
  onStatusUpdate: (id: string, status: string) => Promise<void>;
  onPriorityUpdate: (id: string, priority: string) => Promise<void>;
  onRefresh: () => void;
}

export const ContactLeadActionsMenu = ({
  contactId,
  contactData,
  onStatusUpdate,
  onPriorityUpdate,
  onRefresh,
}: ContactLeadActionsMenuProps) => {
  const [notesOpen, setNotesOpen] = useState(false);
  const [detailsOpen, setDetailsOpen] = useState(false);

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="ghost" size="sm">
            <MoreVertical className="h-4 w-4" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="w-56">
          <DropdownMenuLabel>Actions</DropdownMenuLabel>
          <DropdownMenuSeparator />
          
          <DropdownMenuItem onClick={() => setDetailsOpen(true)}>
            <FileText className="mr-2 h-4 w-4" />
            View Details
          </DropdownMenuItem>
          
          <DropdownMenuItem onClick={() => setNotesOpen(true)}>
            <FileText className="mr-2 h-4 w-4" />
            Add Note
          </DropdownMenuItem>

          <DropdownMenuItem onClick={() => window.location.href = `tel:${contactData.phone}`}>
            <Phone className="mr-2 h-4 w-4" />
            Call Contact
          </DropdownMenuItem>

          <DropdownMenuItem onClick={() => window.location.href = `mailto:${contactData.email}`}>
            <Mail className="mr-2 h-4 w-4" />
            Send Email
          </DropdownMenuItem>

          <DropdownMenuSeparator />
          <DropdownMenuLabel>Lead Status</DropdownMenuLabel>
          
          <DropdownMenuItem onClick={() => onStatusUpdate(contactId, "contacted")}>
            Mark as Contacted
          </DropdownMenuItem>
          <DropdownMenuItem onClick={() => onStatusUpdate(contactId, "qualified")}>
            Mark as Qualified
          </DropdownMenuItem>
          <DropdownMenuItem onClick={() => onStatusUpdate(contactId, "callback_scheduled")}>
            Schedule Callback
          </DropdownMenuItem>
          <DropdownMenuItem onClick={() => onStatusUpdate(contactId, "converted")}>
            Mark as Converted
          </DropdownMenuItem>

          <DropdownMenuSeparator />
          <DropdownMenuLabel>Priority</DropdownMenuLabel>
          
          <DropdownMenuItem onClick={() => onPriorityUpdate(contactId, "urgent")}>
            Set as Urgent
          </DropdownMenuItem>
          <DropdownMenuItem onClick={() => onPriorityUpdate(contactId, "high")}>
            Set as High
          </DropdownMenuItem>
          <DropdownMenuItem onClick={() => onPriorityUpdate(contactId, "medium")}>
            Set as Medium
          </DropdownMenuItem>
          <DropdownMenuItem onClick={() => onPriorityUpdate(contactId, "low")}>
            Set as Low
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>

      <ContactNotesDialog
        open={notesOpen}
        onOpenChange={setNotesOpen}
        contactId={contactId}
        onSuccess={onRefresh}
      />

      <ContactDetailsDialog
        open={detailsOpen}
        onOpenChange={setDetailsOpen}
        contactId={contactId}
        contactData={contactData}
        onSuccess={onRefresh}
      />
    </>
  );
};
